import React from 'react';
import { Row } from 'reactstrap';
import config from '../../../../../config';
import TableBuilder from '../../../../../shared/components/table/TableBuilder';
import {
  currencyFormatter, formatFixedTwoPercent, formatNumberOnePlaceDefaultToZero, getExportPrefix,
} from '../../../../../shared/components/table/functions';


export default function SbCampaignsTable() {
  const columnDefs = [
    { field: 'campaignId', headerName: 'Campaign ID' },
    { field: 'campaignNameMax', headerName: 'Campaign Name (Max)' },
    { field: 'campaignStatusCsv', headerName: 'Status CSV' },
    { field: 'campaignBudgetCurrencyCodeCsv', headerName: 'Budget Currency Code CSV' },
    { field: 'campaignBudgetTypeCsv', headerName: 'Budget Type CSV' },
    { field: 'costTypeCsv', headerName: 'Cost Type CSV' },
    { field: 'addToCart', headerName: 'Add To Cart' },
    { field: 'addToCartClicks', headerName: 'Add To Cart Clicks' },
    { field: 'addToCartRate', headerName: 'Add To Cart Rate', valueFormatter: formatNumberOnePlaceDefaultToZero },
    { field: 'brandedSearches', headerName: 'Branded Searches' },
    { field: 'brandedSearchesClicks', headerName: 'Branded Searches Clicks' },
    { field: 'campaignBudgetAmount', headerName: 'Budget Amount', valueFormatter: currencyFormatter },
    { field: 'clicks', headerName: 'Clicks' },
    { field: 'cost', headerName: 'Spend', valueFormatter: currencyFormatter },
    { field: 'detailPageViews', headerName: 'Detail Page Views' },
    { field: 'detailPageViewsClicks', headerName: 'Detail Page Views Clicks' },
    { field: 'eCPAddToCart', headerName: 'eCP Add To Cart' },
    { field: 'impressions', headerName: 'Impressions' },
    { field: 'newToBrandDetailPageViewRate', headerName: 'NTB Detail Page View Rate', valueFormatter: formatNumberOnePlaceDefaultToZero },
    { field: 'newToBrandDetailPageViews', headerName: 'NTB Detail Page Views' },
    { field: 'newToBrandDetailPageViewsClicks', headerName: 'NTB Detail Page Views Clicks' },
    { field: 'newToBrandECPDetailPageView', headerName: 'NTB eCP Detail Page View' },
    { field: 'newToBrandPurchases', headerName: 'NTB Purchases', valueFormatter: currencyFormatter },
    { field: 'newToBrandPurchasesClicks', headerName: 'NTB Purchases Clicks' },
    { field: 'newToBrandPurchasesPercentage', headerName: 'NTB Purchases Percentage', valueFormatter: formatFixedTwoPercent },
    { field: 'newToBrandPurchasesRate', headerName: 'NTB Purchases Rate', valueFormatter: formatNumberOnePlaceDefaultToZero },
    { field: 'newToBrandSales', headerName: 'NTB Sales', valueFormatter: currencyFormatter },
    { field: 'newToBrandSalesClicks', headerName: 'NTB Sales Clicks' },
    { field: 'newToBrandSalesPercentage', headerName: 'NTB Sales Percentage', valueFormatter: formatFixedTwoPercent },
    { field: 'newToBrandUnitsSold', headerName: 'NTB Units Sold' },
    { field: 'newToBrandUnitsSoldClicks', headerName: 'NTB Units Sold Clicks' },
    { field: 'newToBrandUnitsSoldPercentage', headerName: 'NTB Units Sold Percentage', valueFormatter: formatFixedTwoPercent },
    { field: 'purchases', headerName: 'Purchases', valueFormatter: currencyFormatter },
    { field: 'purchasesClicks', headerName: 'Purchases Clicks' },
    { field: 'purchasesPromoted', headerName: 'Purchases Promoted' },
    { field: 'sales', headerName: 'Sales', valueFormatter: currencyFormatter },
    { field: 'salesClicks', headerName: 'Sales Clicks', valueFormatter: currencyFormatter },
    { field: 'salesPromoted', headerName: 'Sales Promoted', valueFormatter: currencyFormatter },
    { field: 'topOfSearchImpressionShare', headerName: 'Top Of Search Impression Share' },
    { field: 'unitsSold', headerName: 'Units Sold' },
    { field: 'unitsSoldClicks', headerName: 'Units Sold Clicks' },
    { field: 'video5SecondViewRate', headerName: 'Video 5 Second View Rate', valueFormatter: formatNumberOnePlaceDefaultToZero },
    { field: 'video5SecondViews', headerName: 'Video 5 Second Views' },
    { field: 'videoCompleteViews', headerName: 'Video Complete Views' },
    { field: 'videoFirstQuartileViews', headerName: 'Video First Quartile Views' },
    { field: 'videoMidpointViews', headerName: 'Video Midpoint Views' },
    { field: 'videoThirdQuartileViews', headerName: 'Video Third Quartile Views' },
    { field: 'videoUnmutes', headerName: 'Video Unmutes' },
    { field: 'viewabilityRate', headerName: 'Viewability Rate', valueFormatter: formatNumberOnePlaceDefaultToZero },
    { field: 'viewableImpressions', headerName: 'Viewable Impressions' },
    { field: 'viewClickThroughRate', headerName: 'View Click Through Rate', valueFormatter: formatNumberOnePlaceDefaultToZero },
  ];

  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    cellStyle: (params) => {
      if (params.value < 0.00) {
        return { color: 'red' };
      }
      return null;
    },
    showDatePicker: true,
    showFooter: true,
  };

  const showExportOptions = true;
  const apiEndPoint = `${config.serverUrl}/customers/amz/sp/campaigns`;

  const exportPrefix = getExportPrefix('sb-campaigns');

  return (
    <>
      <Row>
        <TableBuilder
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          apiEndPoint={apiEndPoint}
          showDatePicker
          defaultStartDays={14}
          defaultEndDays={1}
          exportPrefix={exportPrefix}
          showExportOptions={showExportOptions}
        />
      </Row>
    </>
  );
}
